<p *ngIf="data.title">{{ data.title }}</p>
<p *ngIf="data.message">{{ data.message }}</p>
<p *ngIf="data.warning" class="red">{{ data.warning }}</p>
<div mat-dialog-actions class="actions">
  <button (click)="onDismiss()" mat-raised-button color="accent" id="btn-no">No</button>
  <button (click)="onConfirm()" mat-raised-button color="primary" id="btn-yes">Yes</button>
</div>